import { render, staticRenderFns } from "./FreightItemDetail.vue?vue&type=template&id=f93e0912&scoped=true&"
import script from "./FreightItemDetail.vue?vue&type=script&lang=js&"
export * from "./FreightItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./FreightItemDetail.vue?vue&type=style&index=0&id=f93e0912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e0912",
  null
  
)

export default component.exports